import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  IconButton,
  PreAuthBookingTable,
  RouteWrapper,
  HeadingSection,
  Section,
} from '../../components';

const Route = ({ dispatch }) => (
  <RouteWrapper
    title="Pre-Auth Bookings"
    requireAuth
    requirePermission="MANAGE_PAYMENTS"
  >
    <HeadingSection
      title="Pre-Auth Bookings"
      controls={[
        <IconButton
          key="pending-account"
          icon="undo"
          className="is-default is-pulled-right"
          handleClick={() => {
            dispatch(goBack());
          }}
        >
          Return
        </IconButton>,
      ]}
    />
    <Section>
      <PreAuthBookingTable />
    </Section>
  </RouteWrapper>
);

export default connect()(Route);
